const syncDocumentTypes = {
  DRAFT_FOLDER: "DraftFolder",
  RESEARCH_FOLDER: "ResearchFolder",
  FOLDER: "Folder",
  TEXT: "Text"
};

export const getDefaultIconForSyncType = (type, hasChildren) => {
  if (type === syncDocumentTypes.DRAFT_FOLDER) {
    return "sync-book";
  } else if (type === syncDocumentTypes.FOLDER) {
    return "sync-folder";
  } else if (hasChildren) {
    return "sync-multiple-docs";
  } else {
    return "sync-document";
  }
};

export default syncDocumentTypes;
